import styled from 'styled-components';

import { toVw, toVwMobile, toVwTablet } from '../../../../utils/styles';
import mq from '@/utils/media-queries';

const TITLE_MARGIN_BOTTOM = 40;

export const Title = styled.div`
  color: ${props => props.theme.colorMinor};
  margin-bottom: ${toVw(TITLE_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(TITLE_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(TITLE_MARGIN_BOTTOM)};
  `)};
`;

const ITEM_MARGIN_BOTTOM = 22;

export const Item = styled.div`
  margin-bottom: ${toVw(ITEM_MARGIN_BOTTOM)};

  &:last-child {
    margin-bottom: 0;
  }

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(ITEM_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(ITEM_MARGIN_BOTTOM)};
  `)};
`;



// WEBPACK FOOTER //
// ./src/scenes/Vacancy/components/Duties/index.js